import { Button, CircularProgress } from "@mui/material";
import googleLogo from "../../assets/images/google-g.png";

interface GoogleAuthButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const GoogleAuthButton = ({
  loading = false,
  disabled = false,
  onClick,
}: GoogleAuthButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={loading || disabled}
      aria-label="Google"
      sx={{
        width: 74,
        height: 74,
        minWidth: 74,
        borderRadius: "50%",
        bgcolor: "#f3f4f6",
        boxShadow: "none",
        "&:hover": {
          bgcolor: "#e5e7eb",
        },
      }}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: "#4285F4" }} />
      ) : (
        <img
          src={googleLogo}
          alt="Google"
          style={{
            width: 34,
            height: 34,
            objectFit: "contain",
          }}
        />
      )}
    </Button>
  );
};

export default GoogleAuthButton;
